import { gql } from '@apollo/client'

export const BUSINESS_UNITS_TREE_QUERY = gql`
  query BUSINESS_UNITS_TREE_QUERY($pagination: PaginationInput, $filter: BusinessUnitFilterInput) {
    businessUnits(pagination: $pagination, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        code
        active
        expanded
        parentId
        description
        createdAt
        position
        parent {
          id
          description
        }
        integrations {
          provider
          externalId
          syncedAt
        }
      }
    }
  }
`

export const BUSINESS_UNITS_SELECT_QUERY = gql`
  query BUSINESS_UNITS_SELECT_QUERY($filter: BusinessUnitFilterInput) {
    businessUnits(filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        active
        description
        parent {
          id
          description
        }
      }
    }
  }
`

export const BUSINESS_UNITS_HIERARCHY_QUERY = gql`
  query BUSINESS_UNITS_HIERARCHY_QUERY {
    businessUnitsHierarchy {
      data {
        id
        type
        parentId
        planId
        planCompanyId
        planParentPlanId
        description
      }
    }
  }
`
